import React, { useEffect/* , { useState } */  } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import { Url } from '@wix/da-url';
import CloseIcon from '@wix/da-ds/pkg/Icons/24x24/Close';
import noop from '../../../utils/noop';
import TierSidebarCard from '../../../DeviationViews/TierSidebarCard';
import s from './SubscriptionLockFTUE.scss';
const ILLUSTRATION_URL = Url.staticCDNLink('eclipse/global/svg/fella-pointing.svg');
/** Displays a ftue popup for first time viewers of in-tier (non-lit/journal) deviations
 *  from Sidebar/_partials/TiersBlock that highlights the first tier sidebar card. */ export const SubscriptionLockFTUE = ({ deviation, className, dropFlag = noop })=>{
    const { t } = useTranslation();
    const isMounted = useIsMounted();
    useEffect(()=>{
        typeof window !== 'undefined' && window.addEventListener('scroll', dropFlag, {
            once: true
        });
        return ()=>window.removeEventListener('scroll', dropFlag);
    }, [
        dropFlag
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], isMounted && s['mounted'], className),
        onClick: dropFlag
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['overlay']
    }), /*#__PURE__*/ React.createElement(TierSidebarCard, {
        className: s['sidebar-card'],
        deviation: deviation
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['fella-popup']
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['fake-close-button']
    }, /*#__PURE__*/ React.createElement(CloseIcon, null)), /*#__PURE__*/ React.createElement("img", {
        className: s['fella'],
        src: ILLUSTRATION_URL,
        alt: ""
    }), /*#__PURE__*/ React.createElement("svg", {
        className: s['arrow'],
        viewBox: "0 0 144 144",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        opacity: "0.4",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M131.199 74.6555L121.717 75.8871C121.08 75.9427 120.454 75.5741 120.33 74.8639C120.274 74.226 120.642 73.5982 121.351 73.4736L132.395 72.0391C133.245 71.9178 134.157 72.1517 134.776 72.8031C135.396 73.4544 135.589 74.237 135.356 75.151L133.333 86.0661C133.254 86.4178 133.178 86.6282 133.034 86.7663C132.745 87.0423 132.391 87.1046 131.967 87.0945C131.334 87.0087 130.855 86.3607 131.013 85.6572L132.702 76.5469C113.327 97.3819 40.4095 110.657 4.51102 64.7126C4.19302 64.1663 4.35426 63.3764 4.89938 63.0577C5.44449 62.739 6.23265 62.9006 6.55065 63.4469C40.5234 105.719 110.02 96.1615 131.199 74.6555Z"
    })), /*#__PURE__*/ React.createElement("p", {
        className: s['ftue-explanation']
    }, t('deviation.tier.ftue.subscriptionLock'), /*#__PURE__*/ React.createElement("span", {
        className: s['fake-link']
    }, t('common.gotIt')))));
};
SubscriptionLockFTUE.displayName = 'SubscriptionLockFTUE';
export default SubscriptionLockFTUE;
